import { openTelegramLink } from "@telegram-apps/sdk-react";
import { CHAIN_IDS } from "@uxuycom/web3-tg-sdk";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { ButtonCell } from "~/components/ButtonCell/ButtonCell";
import { IconTokenRisk } from "~/components/Iconfont/Iconfont";
import { tgLink, tgLinkType } from "~/utils/tgLink";
import { isBuiltInToken } from "../Trade/utils";

export type TokenRiskBtnProps = {
    risk_level?: 0 | 1 | 2 | 3;
    chain_id?: string;
    contract?: string;
};

const TokenRiskBtn: React.FC<TokenRiskBtnProps> = ({
    chain_id,
    contract,
    risk_level = 0,
}) => {
    const { t } = useTranslation();
    const TokenRiskMap = {
        0: {
            iconClassName: "text-text_1",
            text: t("detection"),
        },
        1: {
            iconClassName: "text-text_1",
            text: t("detection"),
        },
        2: {
            iconClassName: "text-text_danger",
            text: t("risk"),
        },
        3: {
            iconClassName: "text-text_buy",
            text: t("safe"),
        },
    };

    const item = TokenRiskMap[risk_level];

    const clickEvent = () => {
        const url = tgLink._getLink(tgLinkType.D, {
            params: {
                url: `https://gopluslabs.io/token-security/${String(chain_id) === String(CHAIN_IDS.SOLANA) ? "solana" : chain_id}/${isBuiltInToken(contract) ? "" : contract}`,
            },
        });
        openTelegramLink(url!);
    };

    return (
        <ButtonCell
            className="!flex-none !w-[55px] !h-[44px] px-0 py-0 overflow-hidden"
            onClick={clickEvent}
        >
            <div className="w-[55px] flex flex-col items-center justify-center h-[44px] rounded-[12px] bg-transparent">
                <IconTokenRisk
                    className={clsx(
                        "text-h4 transition-colors",
                        item.iconClassName
                    )}
                />
                <div
                    className={clsx(
                        "text-direction3 font-Regular whitespace-nowrap mt-[2px] transition-colors",
                        item.iconClassName
                    )}
                >
                    {item.text ?? t("detection")}
                </div>
            </div>
        </ButtonCell>
    );
};

export default TokenRiskBtn;
